import { useWindowSize } from "@components/window-size-provider";
import useSubscriptionType from "@hooks/useSubscriptionType";
import { SubscriptionTypes } from "@lib/constants";
import { getWordpressUrl } from "@lib/wordpressVars";
import MembershipPlansDesktop from "@mwPages/membership-plans/MembershipPlansDesktop";
import MembershipPlansMobile from "@mwPages/membership-plans/MembershipPlansMobile";
import { useGetPageBySlugQuery } from "@services/Page";
import { Layout, Row } from "antd";
import { useMemo } from "react";
import { Helmet as Head } from "react-helmet-async";
import sign_up_header_img from "@images/sign_up_header.png";

const MembershipPlans = ({}) => {
    const windowDimensions = useWindowSize();
    const pageQuery = useGetPageBySlugQuery({slug: 'membership-options-content/'});
    const subscriptionType = useSubscriptionType();

    const showDesktopView = useMemo(() => {
        return windowDimensions.over(799);
    }, [windowDimensions]);

    const pageContent = useMemo(() => {
        if(pageQuery.data) {
            const data = pageQuery.data.layout_builder;

            return {
                imageSrc: data.image.src,
                focalPoint: data.image.focalPoint,
                membershipsTiers : [
                    {
                        name: 'Basic',
                        price: 'Free',
                        best: false,
                        btn_active: !subscriptionType.isLoggedIn,
                        btn_text: !subscriptionType.isLoggedIn ? 'Sign Up' : "Included",
                        btn_link: !subscriptionType.isLoggedIn ? '/register' : `/profile/#subscription-information`,
                        btn_class: 'sign-up-button-white',
                    },
                    {
                        name: 'Standard',
                        price: '$4.95/m',
                        best: false,
                        btn_active: true,
                        btn_text: !subscriptionType.isLoggedIn ? 'Sign Up' : subscriptionType.isStandard ? 'Unsubscribe' : subscriptionType.testIsUpgradeFrom(SubscriptionTypes.STANDARD) ? 'Upgrade' : 'Downgrade',
                        btn_link: !subscriptionType.isLoggedIn ? '/register' : subscriptionType.isStandard ? '/profile/#subscription-information' : '/register/standard/?cp_membership_message=' + (subscriptionType.testIsUpgradeFrom(SubscriptionTypes.STANDARD) ? 'upgrade' : 'downgrade'),
                        btn_class:  subscriptionType.isStandard ? 'sign-up-button-white' : 'sign-up-button-green',
                    },
                    {
                        name: 'Premium (Monthly)',
                        price: '$8.95/m',
                        best: false,
                        btn_active: true,
                        btn_text: !subscriptionType.isLoggedIn ? 'Sign Up' : subscriptionType.isUnlimitedMonthly ? 'Unsubscribe' : subscriptionType.testIsUpgradeFrom(SubscriptionTypes.UNLIMITED_MONTHLY) ? 'Upgrade' : 'Downgrade',
                        btn_link: !subscriptionType.isLoggedIn ? '/register' : subscriptionType.isUnlimitedMonthly ? '/profile/#subscription-information' : '/register/unlimited-monthly/?cp_membership_message=' + (subscriptionType.testIsUpgradeFrom(SubscriptionTypes.UNLIMITED_MONTHLY) ? 'upgrade' : 'downgrade'),
                        btn_class: subscriptionType.isUnlimitedMonthly ? 'sign-up-button-white' : 'sign-up-button-green',
                    },
                    {
                        name: 'Premium (Annual)',
                        price: '$89.95/y ($7.50/m)',
                        best: true,
                        btn_active: true,
                        btn_text: !subscriptionType.isLoggedIn ? 'Sign Up' : subscriptionType.isUnlimitedYearly ? 'Unsubscribe' : subscriptionType.testIsUpgradeFrom(SubscriptionTypes.UNLIMITED_YEARLY) ? 'Upgrade' : 'Downgrade',
                        btn_link: !subscriptionType.isLoggedIn ? '/register' : subscriptionType.isUnlimitedYearly ? '/profile/#subscription-information' : '/register/unlimited-yearly/?cp_membership_message=' + (subscriptionType.testIsUpgradeFrom(SubscriptionTypes.UNLIMITED_YEARLY) ? 'upgrade' : 'downgrade'),
                        btn_class: subscriptionType.isUnlimitedYearly ? 'sign-up-button-white' : 'sign-up-button-green-light',
                    },
                ],
                membershipOptions: [
                    {
                        name: 'Collection Management',
                        options: [
                            {name: 'Collection Management', tiers:['50 Comic Limit','100 Comic Limit',true,true]},
                            {name: 'Total Collection Value Summary', tiers:[false,false,true,true]},
                            {name: 'Collection Dashboard', tiers:[false,false,true,true]},
                            {name: 'Hot / Key / Rare Indicators', tiers:['limited','limited',true,true]},
                            {name: 'Full Filtering / Sorting Options', tiers:['limited','limited',true,true]},
                            {name: 'Series View', tiers:['limited','limited',true,true]},
                            {name: 'Virtual Boxes (sub-collections)', tiers:[false,false,true,true]},
                            {name: 'Wishlist', tiers:['limited','limited',true,true]},
                        ]
                    },
                    {
                        name: 'Price Guides',
                        options: [
                            {name: 'Access to Price Tables (Raw & Graded)', tiers:[false,true,true,true]},
                            {name: 'Value Ribbon (Quick View)', tiers:[false,true,true,true]},
                            {name: 'Comic Value Overview', tiers:[false,true,true,true]},
                            {name: 'Value Trends', tiers:[false,true,true,true]},
                        ]
                    },
                    {
                        name: 'Comic Content & Market Reports',
                        options: [
                            {name: 'Weekly Shaker Reports', tiers:[true,true,true,true]},
                            {name: 'Day After Wednesday Articles', tiers:[true,true,true,true]},
                            {name: 'Final Order-Cut Off (FOC) Articles ', tiers:[true,true,true,true]},
                            {name: 'New Comic Book Day Articles ', tiers:[true,true,true,true]},
                            {name: 'Top 10 Reflective Report', tiers:[true,true,true,true]},
                            {name: 'Weekly Top 10 Reports', tiers:[true,true,true,true]},
                            {name: 'How To & Resource Articles', tiers:[true,true,true,true]},
                        ]
                    },
                    {
                        name: 'New Release',
                        options: [
                            {name: 'Weekly New Release Comic Info', tiers:[true,true,true,true]},
                            {name: 'Archived New Release Items', tiers:[false,false,true,true]},
                            {name: 'Upcoming New Release Items', tiers:[false,false,true,true]},
                            {name: 'Filter by Est. Value for New Releases', tiers:['limited','limited',true,true]},
                        ]
                    },
                    {
                        name: 'Aggregated Marketplace',
                        options: [
                            {name: 'View Items for Sale (eBay/MCS)', tiers:[true,true,true,true]},
                        ]
                    },
                    {
                        name: 'CLZ Integration (CLZ.com)',
                        options: [
                            {name: 'View CovrPrice Sales on CLZ', tiers:[false,false,true,true]},
                        ]
                    },
                ],
            };
        }
        return null;
    }, [pageQuery, subscriptionType]);

    return (
        <Layout className={`partials membership-plans`} >
            <Head>
                <title>Membership Plans - CovrPrice</title>
            </Head>
            {pageContent && (
                <>
                    <Row className="top-box flex-align-center flex-vertical-center mar-top-40 mar-bot-10" style={{
                        background: `url(${getWordpressUrl(sign_up_header_img)}) no-repeat center center`,
                    }}>
                        <div className="top-box-content">
                            <p className="top-title">COVR<span style={{fontWeight: 400}}>PRICE</span> Is The Only Comic Book Resource You’ll Ever Need.</p>
                        </div>
                    </Row>

                    {showDesktopView ?
                        <MembershipPlansDesktop pageContent={pageContent} subscriptionType={subscriptionType} /> :
                        <MembershipPlansMobile  pageContent={pageContent} subscriptionType={subscriptionType} />
                    }
                </>
            )}

        </Layout>
    );
};

export default MembershipPlans;
